<template>
    <div class="box-manage">
        <mt-header title="提箱"></mt-header>
        <mt-index-list>
            <mt-index-section v-for="(items, index) in boxBill" :key="index" :index="index">
                <mt-cell v-for="item in items" :title="item.boxno+' 箱区:'+item.area" :label="item.label" :key="item.boxno"
                         :to="{path:'/box-manage/form',query:{boxno:item.boxno,id:item.id,type:'out'}}" is-link>
                    <van-button size="small" type="primary">{{ item.in_status }}</van-button>
                </mt-cell>
            </mt-index-section>
            <mt-index-section index="">
                <mt-cell></mt-cell>
            </mt-index-section>
        </mt-index-list>

        <van-tabbar v-model="active">
            <van-tabbar-item to="/box-manage/home" name="fan" icon="home-o" :badge="badge.fan">翻箱</van-tabbar-item>
            <van-tabbar-item to="/box-manage/in" name="in" icon="home-o" :badge="badge.in">落箱</van-tabbar-item>
            <van-tabbar-item to="/box-manage/out" name="out" icon="home-o" :badge="badge.out">提箱</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {IndexList, IndexSection} from 'mint-ui';
    import {Tabbar, TabbarItem} from 'vant';

    Vue.use(Tabbar);
    Vue.use(TabbarItem);
    Vue.component(IndexList.name, IndexList);
    Vue.component(IndexSection.name, IndexSection);

    export default {
        data() {
            return {
                boxno: '',
                boxBill: [],
                active: 'out',
                badge: [],
            };
        },
        methods: {
            onSubmit(values) {

            },
            //获取列表
            getList() {
                let querystring = require('querystring');
                this.$api.post('wx/box-manage/list',
                    querystring.stringify({
                        tel: localStorage.getItem("tel"),
                        user_id: localStorage.getItem("id"),
                        type: this.active,
                    })
                ).then(data => {
                    if (data.data.status == 1) {
                        this.boxBill = data.data.data;
                        this.badge = data.data.badge;
                    } else {
                        Dialog.alert({
                            message: data.data.msg,
                        }).then(() => {

                        });
                    }
                }).catch(err => {
                    console.log(err);
                })
            },
        },
        mounted() {
            this.getList();
        }
    }
</script>

<style scoped>
    .box-manage{
        text-align: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/box-manage/out.vue